import React from "react";
import { Box, Checkbox, Typography } from "@mui/material";

export const OperativosSelectionSummary = ({
	allCurrentPageSelected,
	disabled,
	someCurrentPageSelected,
	onToggleCurrentPageSelection,
	currentCaboGroupsCount,
	currentPartesCount,
}) => (
	<Box
		sx={{
			display: "flex",
			alignItems: "center",
			justifyContent: "space-between",
			px: 2,
			py: 1.25,
			borderRadius: 2,
			bgcolor: "grey.100",
			border: "1px solid",
			borderColor: "divider",
			gap: 2,
			flexWrap: "wrap",
		}}
	>
		<Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
			<Checkbox
				checked={Boolean(allCurrentPageSelected)}
				disabled={disabled}
				indeterminate={!allCurrentPageSelected && Boolean(someCurrentPageSelected)}
				onChange={(event) => onToggleCurrentPageSelection(event.target.checked)}
				size="small"
			/>
			<Typography variant="subtitle2">Seleccionar cabos visibles</Typography>
		</Box>
		<Typography variant="body2" color="text.secondary">
			{currentCaboGroupsCount} cabo(s) en esta pagina · {currentPartesCount} parte(s)
		</Typography>
	</Box>
);
